import Provider from './SponsoredProductsProvider';

export default Provider;
